export default {
  greeting: "bonjour c'est la page d'accueil",
  intro: 'Bienvenue sur SaralWeb, nous sommes une entreprise technologique de pointe dédiée à fournir des'
}
